<nz-spin [nzSpinning]="loading$ | async">
  <ng-container *ngIf="data$ | async as items">
    <ng-container *ngIf="items.length > 0">
      <nz-divider></nz-divider>

      <nz-tag
        *ngFor="let item of items; trackBy: trackByValue"
        nzColor="blue"
      >
        {{ item }}
      </nz-tag>

      <nz-divider></nz-divider>
    </ng-container>
  </ng-container>
</nz-spin>
